import { SxProps } from "@mui/material";

export const sxInputSendEmailFormFull: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '485px'
}

export const sxBoxSendEmailForm: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '25px'
}

export const sxMessageTextField: SxProps = {
  "& .MuiOutlinedInput-root": {
    alignItems: 'flex-start',
    height: 'unset',
    minHeight: '150px',
    fontFamily: 'Unimed-Sans',
  },
  "& .MuiOutlinedInput-input": {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontSize: '14px',
  },
}

export const sxMessageTextFieldContrast: SxProps = {
  "& .MuiOutlinedInput-root": {
    alignItems: 'flex-start',
    height: 'unset',
    minHeight: '150px',
    fontFamily: 'Unimed-Sans',
    backgroundColor: 'black',
  },
  "& .MuiOutlinedInput-input": {
    fontFamily: 'Unimed-Sans',
    color: 'white',
    fontSize: '14px',
    borderColor: 'white',
  },
}
